import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, ThemeProvider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import StudentJournalBlock from './StudentJournalBlock';
import { journalTheme } from '../../utils/consts/journalTheme';

/**
 * Журнал слушателя в модальном окне — рядом с «Файлы студента» и «Написать письмо».
 *
 * В карточке этот блок стоял внутри формы и ломал её вёрстку: карточка свёрстана
 * колонками фиксированной ширины, а блок с таблицей и полями в них не помещался.
 * Как отдельное действие он и логичнее: это не поле карточки, а смежный раздел.
 */
const StudentJournalModal = ({ open, studentId, studentName, onClose }) => (
  <ThemeProvider theme={journalTheme}>
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth scroll="paper">
      <DialogTitle sx={{ pr: 6 }}>
        Электронный журнал — {studentName}
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: '#8a8a8a' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {open && <StudentJournalBlock studentId={studentId} embedded />}
      </DialogContent>
    </Dialog>
  </ThemeProvider>
);

export default StudentJournalModal;
